<template>
	<div class="display_inline_block" :class="{ has_error: has_error }">
		<div>
			<checkbox v-model="is_rebase" :checked="is_rebase">Rebase</checkbox>
		</div>
		<div class="vertical_space"></div>
		<div>
			<checkbox v-model="is_office" :checked="is_office">Office</checkbox>
		</div>
		<div class="vertical_space"></div>
		<div>
			<checkbox v-model="is_suitup" :checked="is_suitup">Suitup</checkbox>
		</div>
		<div class="vertical_space"></div>
		<div>
			<checkbox v-model="is_piola" :checked="is_piola">Piola</checkbox>
		</div>
	</div>
</template>
<script>
	import Checkbox from '@/components/Checkbox'
	export default {
		name: 'env-chooser',
		props: ['env', 'has_error'],
		data(){
			return {
				is_suitup: this.env == 'Suitup',
				is_rebase: this.env == 'Rebase',
				is_office: this.env == 'Office',
				is_piola: this.env == 'Piola',
			}
		},
		watch: {
			is_rebase(new_value){
				if(this.is_rebase){
					this.$emit('input', 'Rebase')
					this.is_suitup = false
					this.is_office = false
					this.is_piola = false
				}
			},
			is_suitup(new_value){
				if(this.is_suitup){
					this.$emit('input', 'Suitup')
					this.is_rebase = false
					this.is_office = false
					this.is_piola = false
				}
			},
			is_office(new_value){
				if(this.is_office){
					this.$emit('input', 'Office')
					this.is_suitup = false
					this.is_rebase = false
					this.is_piola = false
				}
			},
			is_piola(new_value){
				if(this.is_piola){
					this.$emit('input', 'Piola')
					this.is_suitup = false
					this.is_office = false
					this.is_rebase = false
				}
			}
		},
		components: {
			Checkbox
		}
	}
</script>
<style scoped>
	.has_error{
		border: 1px solid red;
	}
</style>